import { PathPickProduct } from "@/features/pathpick/types";
import useMarketOptionsHoverPrefetch from "@/features/pathpick/hooks/query/useMarketOptionsHoverPrefetch";
import { kreamOptionsQuery } from "@/features/pathpick/hooks/query/useGetKreamOptions";
import { poizonOptionsQuery } from "@/features/pathpick/hooks/query/useGetPoizonOptions";

/**
 * 상품 1건의 상세 모달에 필요한 옵션 조회(크림 + 포이즌)를 hover 시 함께 미리 당긴다.
 *
 * 상세 모달은 두 마켓 옵션을 같이 그리므로 한쪽만 당겨 두면 모달이 반쪽만 채운 채 열린다.
 * 반환한 { onMouseEnter, onMouseLeave } 를 hover 트리거에 그대로 펼쳐 쓴다.
 *
 * isDisabled 면 아무 예약도 하지 않는다 — 목 상품만 다루는 시작 가이드가 실제 API를
 * 부르지 않도록 이렇게 끈다.
 */
const usePathPickProductOptionsHoverPrefetch = (
  item: Pick<PathPickProduct, "kream" | "poizon">,
  isDisabled = false
) =>
  useMarketOptionsHoverPrefetch(
    isDisabled
      ? []
      : [
          item.kream?.productId
            ? kreamOptionsQuery(item.kream.productId)
            : undefined,
          item.poizon?.spuId ? poizonOptionsQuery(item.poizon.spuId) : undefined,
        ]
  );

export default usePathPickProductOptionsHoverPrefetch;
